import { getDateFormat } from "../constants";

export type PhaseThreeParameters = {
    initialDate: string;
    typeRate: string;
    amount: number;
    monthlyAmount: number;
    employeeNumber: number;
    zohoId: string;
    dni?: string;
    name?: string;
    lastName?: string;
    position?: string;
};

export class PhaseThree {
    chECFase_c: string;
    chVidaLeyDeclaracion_c: string;
    cECMonto_c: number;
    cVidaLeyPlanillaMensual_c: number;
    nVidaLeyTrabajadores_c: number;
    OptyNumber: string;
    tVidaLeyRLDNI_c: string;
    tVidaLeyRLNombre_c: string;
    tVidaLeyRLApellido_c: string;
    tVidaLeyRLCargo_c: string;
    dEC_c: string;
    chECAutoTipifEstado_c: string;

    constructor({
        amount,
        dni,
        employeeNumber,
        initialDate,
        lastName,
        monthlyAmount,
        name,
        position,
        typeRate,
        zohoId,
    }: PhaseThreeParameters) {
        this.chECFase_c = "resumen";
        this.chVidaLeyDeclaracion_c = typeRate.toLowerCase();
        this.cECMonto_c = amount;
        this.cVidaLeyPlanillaMensual_c = monthlyAmount;
        this.nVidaLeyTrabajadores_c = employeeNumber;
        this.OptyNumber = zohoId;
        this.tVidaLeyRLDNI_c = dni || "";
        this.tVidaLeyRLNombre_c = name || "";
        this.tVidaLeyRLApellido_c = lastName || "";
        this.tVidaLeyRLCargo_c = position || "";
        this.dEC_c = getDateFormat(initialDate);
        this.chECAutoTipifEstado_c = "solicitar";
    }
}
